import React, { useState } from 'react';
import { trainingApi } from '../../lib/api';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Loader2, Upload } from 'lucide-react';
import { toast } from 'sonner';

export default function UploadFileDialog({ kind, onClose, onUploaded }) {
  const isManual = kind === 'manual';
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState('');
  const [chapterNo, setChapterNo] = useState('');
  const [uploading, setUploading] = useState(false);

  const upload = async () => {
    if (!file) { toast.error('Seleziona un file'); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      fd.append('kind', kind);
      if (title.trim()) fd.append('title', title.trim());
      if (isManual && chapterNo) fd.append('chapter_no', chapterNo);
      const r = await trainingApi.uploadFile(fd);
      toast.success(isManual ? 'Capitolo caricato' : 'Documento caricato');
      onUploaded(r.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Caricamento fallito');
    } finally {
      setUploading(false);
    }
  };

  return (
    <Dialog open onOpenChange={v => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="upload-file-dialog">
        <DialogHeader>
          <DialogTitle>{isManual ? 'Carica capitolo del manuale' : 'Carica documento formativo'}</DialogTitle>
          <DialogDescription>PDF, immagini o file Office — max 25MB.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <label className="text-[10px] uppercase tracking-wider font-semibold text-slate-500">File *</label>
            <Input type="file" accept=".pdf,.png,.jpg,.jpeg,.webp,.docx,.xlsx,.pptx"
                   onChange={e => {
                     const f = e.target.files?.[0] || null;
                     setFile(f);
                     if (f && !title) setTitle(f.name.replace(/\.[^.]+$/, ''));
                   }}
                   className="rounded-none mt-1" data-testid="upload-file-input" />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-wider font-semibold text-slate-500">Titolo</label>
            <Input value={title} onChange={e => setTitle(e.target.value)}
                   className="rounded-none mt-1" data-testid="upload-title-input" />
          </div>
          {isManual && (
            <div>
              <label className="text-[10px] uppercase tracking-wider font-semibold text-slate-500">N° capitolo</label>
              <Input type="number" min="1" value={chapterNo} onChange={e => setChapterNo(e.target.value)}
                     className="rounded-none mt-1" data-testid="upload-chapter-input" />
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={upload} disabled={uploading || !file} data-testid="upload-confirm-btn">
            {uploading ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : <Upload className="w-4 h-4 mr-1.5" />} Carica
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
